import ar from './ar';
import az from './az';
import du from './du';
import en from './en';
import es from './es';
import fr from './fr';
import ru from './ru';
import ind from './in';
import ms from './ms';
import zhm from './zhm';

export default {
  ...en, ...es, ...az, ...ar, ...ru, ...ms, ...fr, ...du, ...ind, ...ms, ...zhm,
};
